import { ref } from '@vue/composition-api'
import store from '@/store'

export default function useWorkplacePayrollValue(refetchData) {
  const loading = ref(false)
  const workplacePayrollValueModal = ref(null)

  const workplacePayrollValueMode = ref({
    workplace_name: null,
    workplace_id: null,
    payroll_value: 0,
  })

  function show(workplace) {
    workplacePayrollValueMode.value.workplace_id = workplace.id
    workplacePayrollValueMode.value.workplace_name = workplace.name
    workplacePayrollValueMode.value.payroll_value = workplace.payroll_value
    workplacePayrollValueModal.value.show()
  }

  function editPayrollValue() {
    loading.value = true
    const payload = {
      workplace_id: workplacePayrollValueMode.value.workplace_id,
      payroll_value: workplacePayrollValueMode.value.payroll_value,
    }
    store.dispatch('app-institution/updatePayrollValue', payload)
      .then(() => {
        refetchData()
        loading.value = false
        workplacePayrollValueModal.value.hide()
      }).catch(() => {
        loading.value = false
      })
  }

  return {
    loading,
    workplacePayrollValueModal,
    workplacePayrollValueMode,
    show,
    editPayrollValue,
  }
}
